<div id="globalInfoTable" style="overflow: auto">
  <cng-agent-planning></cng-agent-planning>
</div>
